module.exports = __webpack_public_path__ + "img/terms.svg";